import identity from 'transmute/identity';
import { getValidationRulesByObjectTypeRpc } from '../../../__generated__/chirp/com/hubspot/property/validation/rpc/PropertyValidationRpc';
import { InMemoryCache } from '../InMemoryCache';
const fetchValidationRules = (objectTypeId, rpcClient) => {
  return rpcClient.call(getValidationRulesByObjectTypeRpc, {
    request: {
      objectTypeId
    }
  }).then(result => result.rulesMap);
};
export const makePropertyValidationRulesCache = () => new InMemoryCache('PropertyValidationRulesCache', identity, ({
  rpcClient
}) => objectTypeId => fetchValidationRules(objectTypeId, rpcClient));